import createAction from '../../../../utils/redux-helpers/createAction';

const handler = (state, { value }) =>
  state.setIn(['tables', 'needToUpdateData'], value);

export const needToUpdateData = createAction({
  action: ['needToUpdateData', 'value'],
  handler,
});
